import { Image, Typography } from '@iheartjane/reefer';
import { clsx } from 'clsx';

import type { CartItem } from '@jane/bloom/types/schemas/bloom/checkout';
import type { CartProduct } from '@jane/bloom/types/schemas/marketplace/cart';
import { getDefaultProductPhoto } from '@jane/bloom/utils/product/getDefaultProductPhoto';

import styles from './bagTransferItem.module.css';

export function BagTransferItem({
  isOutOfStock = false,
  oldProductCount,
  product,
}: {
  isOutOfStock?: boolean;
  oldProductCount?: number;
  product: CartProduct | CartItem;
}) {
  const productRootSubtype =
    'rootSubtype' in product
      ? product.rootSubtype
      : (product as CartProduct).root_subtype;

  const productImageUrl =
    product.photos?.[0]?.urls.original ??
    getDefaultProductPhoto({
      category: product.category,
      kind: product.kind,
      productRootSubtype: productRootSubtype,
      productType: product.type,
    });

  return (
    <div className={styles['productContainer']}>
      <Image
        altText={`${product.name} image`}
        src={productImageUrl}
        border
        borderRadius="8px"
        height="48px"
        width="48px"
        className={clsx({
          [styles['outOfStockProductImage']]: isOutOfStock,
        })}
      />
      <div
        className={clsx(styles['productDetails'], {
          [styles['outOfStockProductText']]: isOutOfStock,
        })}
      >
        <Typography>{product.name}</Typography>
        <Typography color="grays-mid">{product.brand}</Typography>
      </div>
      {isOutOfStock && (
        <div className={styles['outOfStockText']}>
          <Typography color="grays-mid" variant="body-bold" maxLines={1}>
            Out of stock
          </Typography>
        </div>
      )}
      {oldProductCount && (
        <div className={styles['quantityAdjustedText']}>
          <Typography color="grays-mid" variant="body-bold" maxLines={1}>
            {product.count}/{oldProductCount} in stock
          </Typography>
        </div>
      )}
    </div>
  );
}
